'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * permet d'afficher les informations liés à l'exercice comptable/fiscal
 */
ngModule.factory("exerciceService", function ($session) {
  return {
    /**
     * janvier = 1
     */
    getMoisDebutExercice: function getMoisDebutExercice() {
      return $session.getCompte().moisDebutExercice;
    },
    /**
     * janvier = 1
     */
    getMoisFinExercice: function getMoisFinExercice() {
      return $session.getCompte().moisFinExercice;
    },
    /**
     *  si le moisDebutExercice est sur les 8 premiers mois alors c'est l'exercice de l'année N qui commence a ce mois sinon on considère que c'est l'exercice de l'année N+1 qui commence a ce mois
     * @param date
     * @returns {number|*}
     */
    getAnneeExercice: function getAnneeExercice(date) {
      var anneeExercice;
      var moisDebutExercice = $session.getCompte().moisDebutExercice;
      var mois = moment(date).month() + 1;
      if (moisDebutExercice <= 8) {
        if (mois >= moisDebutExercice) {
          anneeExercice = moment(date).year();
        } else {
          anneeExercice = moment(date).year() - 1;
        }
      } else {
        if (mois >= moisDebutExercice) {
          anneeExercice = moment(date).year() + 1;
        } else {
          anneeExercice = moment(date).year();
        }
      }
      console.log(date, anneeExercice);
      return anneeExercice;
    },
    getDateDebutExercice: function getDateDebutExercice(date) {
      var moisDebutExercice = this.getMoisDebutExercice();
      var dateDebutExercice;
      if (moisDebutExercice == null) {
        moisDebutExercice = 1;
      }
      dateDebutExercice = date;
      dateDebutExercice = moment(dateDebutExercice).startOf('months').toDate();
      if (moisDebutExercice > moment(date).get('month') + 1) {
        dateDebutExercice = moment(dateDebutExercice).subtract(1, 'years').toDate();
      }
      dateDebutExercice = moment(dateDebutExercice).set('months', moisDebutExercice - 1).toDate();
      return dateDebutExercice;
    },
    getDateFinExercice: function getDateFinExercice(date) {
      return moment(this.getDateDebutExercice(date)).add(1, 'years').subtract(1, 'days');
    },
    /**
     * "jj/mm" independamment de l'année (toujour 28 pour février)
     */
    getJourEtMoisFinExercice: function getJourEtMoisFinExercice() {
      return $session.getCompte().jourEtMoisFinExercice;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/exerciceService.js
// module id = 2871
// module chunks = 13